import { SENTENCES_STORE } from "./SentencesStore";

class SpeechStore {
	private voicesLoaded = false;

	constructor() {
		// Load voices on initialization
		if ('speechSynthesis' in window) {
			// Try to load voices immediately
			const voices = window.speechSynthesis.getVoices();
			if (voices.length > 0) {
				this.voicesLoaded = true;
			}

			// Also listen for voiceschanged event
			window.speechSynthesis.addEventListener('voiceschanged', () => {
				this.voicesLoaded = true;
			});
		}
	}

	public getAbbrev(lang: string) {
		const l = SENTENCES_STORE.languages.get().find(l => l.abbrev === lang || l.abbrev3 === lang);
		if (!l) return false;
		return l.abbrev.toLowerCase();
	}

	public canSpeak(lang: string) {
		return this.getVoices(lang)?.length > 0;
	}

	public getVoices(lang: string): SpeechSynthesisVoice[] {
		const abbrev = this.getAbbrev(lang);
		if (!abbrev) {
			return [];
		}
		if (!('speechSynthesis' in window)) {
			return [];
		}
		return window.speechSynthesis.getVoices().filter(voice => voice.lang.startsWith(abbrev));
	}

	async speak(text: string, lang: string, opts: {enabledVoices?: string[], speed: number} = {enabledVoices: [], speed: 0.8}) {
		if (!('speechSynthesis' in window)) {
			return;
		}

		// Wait for voices to be loaded if they're not ready yet
		if (!this.voicesLoaded) {
			console.log("Voices not loaded yet");
			return;
		}

		// Cancel any ongoing speech
		window.speechSynthesis.cancel();

		// Get available voices
		let voices = this.getVoices(lang);
		if (voices?.length === 0) {
			console.warn(`No TTS voice found for language: ${lang}`);
			return;
		}

		// Filter by enabled voices if provided
		if (opts.enabledVoices && opts.enabledVoices.length > 0) {
			const filteredVoices = voices.filter(v => opts.enabledVoices?.some(name => name == v.name));
			if (filteredVoices.length > 0) {
				voices = filteredVoices;
			}
			// If no enabled voices match, fall back to all voices
		}

		const rndVoice = voices[Math.floor(Math.random() * voices.length)];

		const utterance = new SpeechSynthesisUtterance(text);
		utterance.voice = rndVoice;
		utterance.lang = rndVoice.lang;
		utterance.rate = opts.speed;
		window.speechSynthesis.speak(utterance);
	}

}

export const SPEECH_STORE = new SpeechStore();